import React, { useCallback, useContext, useState } from "react";
import FilterSecondPage_Bus from "./FilterSecondPage_Bus";
import TopkpisSecond_Bus from "./TopkpisSecond_Bus";
import TopkpisSecondMain_Bus from "./TopkpisSecondMain_Bus";
import "./Driveanalysis_Bus.css";
import Header_Bus from "../LayoutMain_Bus/Header_Bus";
import RealWorldBox_Bus from "./SecondPageCharts_Bus/RealWorldBox_Bus";
import RealWorldBar_Bus from "./SecondPageCharts_Bus/RealWorldBar_Bus";
import NetEnergydBox_Bus from "./SecondPageCharts_Bus/NetEnergydBox_Bus";
import NetEnergyBar_Bus from "./SecondPageCharts_Bus/NetEnergyBar_Bus";
import Torquespeed_Bus from "./SecondPageCharts_Bus/Torquespeed_Bus";
import TorqueBox_Bus from "./SecondPageCharts_Bus/TorqueBox_Bus";
import AvgDDBar_Bus from "./SecondPageCharts_Bus/AvgDDBar_Bus";
import ModeUtilization_Bus from "./SecondPageCharts_Bus/ModeUtilization_Bus";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PageSecond_Bus(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
    CITY: props.gloablfilter.CITY,
    DEPO: props.gloablfilter.DEPO,
  });
  const [chartTypeBox, setChartBoxSelected] = useState("netenergybox");
  const [chartType, setChartSelected] = useState("netenergy");
  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption);
  };
  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption);
  };

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);
  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <FilterSecondPage_Bus
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />

      <div className="container-fluid busdrpg1 pb-1">
        <TopkpisSecond_Bus
          gloablfilter={secondPageState}
          apiend="drivesecondpage_bus/topkpis"
        />
        <TopkpisSecondMain_Bus
          gloablfilter={secondPageState}
          apiend="drivesecondpage_bus/topkpismain"
        />
        <section className="graphs busdrpg1">
          <div className="row mt-4 mb-3 equal-cols">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus p-2">Real World Range Boxplot</div>
                <div className="chartHGT_Bus_Bus">
                  <RealWorldBox_Bus
                    gloablfilter={secondPageState}
                    apiend="drivesecondpage_bus/realworldrangebox_bus"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus p-2">
                  Real World Range Distribution
                </div>
                <div className="chartHGT_Bus">
                  <RealWorldBar_Bus
                    apiend="drivesecondpage_bus/realworldrange_bus"
                    gloablfilter={secondPageState}
                  ></RealWorldBar_Bus>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus p-2">Net Energy Boxplot</div>
                <div className="chartHGT_Bus">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(event) => changeNetBox(event.target.value)}
                      value={chartTypeBox}
                    >
                      <option value="netenergybox">Kwh/km</option>
                      <option value="netkwhbox">kWh</option>
                    </select>
                  </div>
                  {chartTypeBox === "netenergybox" ? (
                    <NetEnergydBox_Bus
                      gloablfilter={secondPageState}
                      apiend="drivesecondpage_bus/energyconsuptionbox_whperkm_bus"
                    ></NetEnergydBox_Bus>
                  ) : (
                    <NetEnergydBox_Bus
                      gloablfilter={secondPageState}
                      apiend="drivesecondpage_bus/energyconsuptionbox_kwh_bus"
                    ></NetEnergydBox_Bus>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus p-2">Net Energy Consumption</div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <select
                    className="form-select form-select-sm"
                    aria-label=".form-select-sm example"
                    onChange={(event) => changeNet(event.target.value)}
                    value={chartType}
                  >
                    <option value="netenergy">Kwh/km</option>
                    <option value="netkwh">kWh</option>
                  </select>
                </div>

                <div className="chartHGT_Bus">
                  {chartType === "netenergy" ? (
                    <NetEnergyBar_Bus
                      apiend="drivesecondpage_bus/energyconsuptionbar_whperkm_bus"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Bus>
                  ) : (
                    <NetEnergyBar_Bus
                      apiend="drivesecondpage_bus/energyconsuptionbar_kwh_bus"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Bus>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-3 equal-cols">
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-lg-3 col-md-6 col-sm-12">
                <Torquespeed_Bus
                  apiend="drivesecondpage_bus/motortorque_bus"
                  gloablfilter={secondPageState}
                ></Torquespeed_Bus>
              </div>
            )}
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-lg-3 col-md-6 col-sm-12">
                <TorqueBox_Bus
                  apiend="drivesecondpage_bus/motortorque_bus"
                  gloablfilter={secondPageState}
                ></TorqueBox_Bus>
              </div>
            )}
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-lg-3 col-md-6 col-sm-12"
                  : "col-lg-6 col-md-4 col-sm-12"
              }
            >
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus drive_last">
                  SoC Discharge/Cycle Analysis
                </div>
                <div className="chartHGT_Bus">
                  <AvgDDBar_Bus
                    apiend="drivesecondpage_bus/socdischarge_bus"
                    gloablfilter={secondPageState}
                  ></AvgDDBar_Bus>
                </div>
              </div>
            </div>

            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-lg-3 col-md-6 col-sm-12"
                  : "col-lg-6 col-md-4 col-sm-12"
              }
            >
              <div className="v-title chartbox chartbox_bus">
                <div className="titlebg_bus drive_last">
                  Discharge Cycle vs Range
                </div>
                <div className="chartHGT_Bus">
                  <ModeUtilization_Bus
                    gloablfilter={secondPageState}
                    apiend="drivesecondpage_bus/socdischarge_vs_range_bus"
                  ></ModeUtilization_Bus>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default PageSecond_Bus;
